<template>
  <div>
    <condensed-issue v-for="article in articles" :key="article.id" v-bind:issue="article"></condensed-issue>
  </div>
</template>

<script>
import CondensedIssue from '@/components/shared/CondensedIssueComponent'
import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
export default {

  components: {
    CondensedIssue
  },
  name: 'advance-online-publications',
  mixins: [ UtilityMixin ],
  data () {
    return {
      articles: []
    }
  },
  created () {
    this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
      this.articles = response.body.articles
    }, function () {
    })
  }

}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// AdvanceOnlinePublicationsPage.vue?b94289c6